<ub-card *ngIf="isReady(); else paymentsLoading">
  <div title>
    <h3 i18n>Payment {{ transaction.stateDescription }}</h3>
  </div>
  <div title *ngIf="hasError()">
    <eas-payments-error [error]="error"></eas-payments-error>
  </div>
  <div content>
    <eas-payments-details *ngIf="state.is('details')"
                          [transaction]="transaction"
                          [isOperationInProgress]="isOperationInProgress"
                          (attempt)="onAttempt()">
    </eas-payments-details>
    <eas-payments-instructions *ngIf="state.is('instructions')"
                               [transaction]="transaction"
                               [isOperationInProgress]="isOperationInProgress"
                               (action)="onAction()"
                               (cancel)="onCancel()">
    </eas-payments-instructions>
    <eas-payments-card-form *ngIf="state.is('card-form')"
                            [transaction]="transaction"
                            [isOperationInProgress]="isOperationInProgress"
                            [integration]="integration"
                            (capture)="onCapture($event)"
                            (cancel)="onCancel()"
                            (error)="onError($event)">
    </eas-payments-card-form>
     <eas-payments-card-action *ngIf="state.is('card-action')"
                              [transaction]="transaction"
                              [isOperationInProgress]="isOperationInProgress"
                              [integration]="integration"
                              [progress]="transactionProgress"
                              (capture)="onCapture($event)"
                              (error)="onError($event)">
    </eas-payments-card-action>
    <eas-payments-capture-form *ngIf="state.is('capture-form')"
                               [transaction]="transaction"
                               [isOperationInProgress]="isOperationInProgress"
                               [paymentMethods]="systemPaymentMethods"
                               (confirm)="onConfirm()">
    </eas-payments-capture-form>
    <eas-payments-outcome *ngIf="state.is('outcome')"
                          [state]="state"
                          [transaction]="transaction"
                          [isOperationInProgress]="isOperationInProgress"
                          (cancel)="onCancel()"
                          (refund)="onRefund($event)"
                          (download)="onDownload()">
    </eas-payments-outcome>

    <br />
    <eas-auditlog [dates]="auditlog$ | async"></eas-auditlog>
  </div>
</ub-card>
<ng-template #paymentsLoading>
  <ub-card>
    <div content i18n>Payment details are loading, please wait.</div>
  </ub-card>
</ng-template>
